import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      errorCount: 0 
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState((prevState) => ({
      error,
      errorInfo,
      errorCount: prevState.errorCount + 1,
    }));
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    
    // Log plus détaillé en développement
    if (process.env.NODE_ENV === "development") {
      console.error("Error details:", {
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      });
    }
  }

  resetError = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            padding: "20px",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              maxWidth: "600px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "32px",
                marginBottom: "16px",
              }}
            >
              ⚠️
            </div>
            <h2 style={{ color: "#d32f2f", marginBottom: "12px" }}>
              Une erreur s&apos;est produite
            </h2>
            <p style={{ color: "#666", marginBottom: "20px", lineHeight: "1.6" }}>
              Une erreur inattendue s&apos;est produite. Veuillez essayer de recharger la page 
              ou contacter le support si le problème persiste.
            </p>
            
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details
                style={{
                  marginTop: "20px",
                  padding: "12px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                <summary style={{ fontWeight: "bold", marginBottom: "8px", color: "#666" }}>
                  Détails de l&apos;erreur (développeur)
                </summary>
                <pre
                  style={{
                    backgroundColor: "#fff",
                    padding: "12px",
                    borderRadius: "4px",
                    overflow: "auto",
                    fontSize: "12px",
                    color: "#d32f2f",
                    marginTop: "8px",
                  }}
                >
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}

            <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginTop: "20px" }}>
              <button
                onClick={this.resetError}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#009688",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Réessayer
              </button>
              <button
                onClick={() => window.location.href = "/"}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#f5f5f5",
                  color: "#333",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Retour à l&apos;accueil
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;